module.exports = __webpack_public_path__ + "static/media/TT-Norms-Pro-DemiBold.62618b59.ttf";